import { observer } from 'mobx-react-lite'
import { useRouterStore } from '../../../RouterStore'
import { routes } from '../../RouteConfig'
import useStore from 'reusable/mobx-store-utils'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button'

export default observer(function AnnouncementFYISyncErrors() {
   const routerStore = useRouterStore()
   const announcementFYISyncErrorsStore = useStore(() => ({
      navigateToClientSyncLog: () => routerStore.navigateToRoute(routes['my-organisation'], 'client-sync-log')
   }))

   return <>
      <ErrorOutlineIcon sx={{ mr: 1, color: 'error.dark', fontSize: '20px' }} />
      Sync from FYI completed with errors.
      <Button variant="text" sx={{ ml: 0.5 }} onClick={announcementFYISyncErrorsStore.navigateToClientSyncLog}>View logs</Button>
   </>
})
